import { render, staticRenderFns } from "./ListaVazia.vue?vue&type=template&id=a811583a"
import script from "./ListaVazia.vue?vue&type=script&lang=js"
export * from "./ListaVazia.vue?vue&type=script&lang=js"
import style0 from "./ListaVazia.vue?vue&type=style&index=0&id=a811583a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports